/** @jsx h */
import { h } from 'preact'

const CloseIcon = () => (
  <svg width='24' height='24' viewBox='0 0 24 24'>
    <g fill='none' fillRule='evenodd'>
      <circle cx='12' cy='12' r='10' stroke='currentColor' strokeWidth={1} />
      <g
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1}
      >
        <path d='M8 16l8-8M8 8l8 8' />
      </g>
    </g>
  </svg>
)

export default CloseIcon
